import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";


function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              isBlog={false}
              title="Gesture Recognition"
              description="A real time gesture recognition app using Tensorflow.JS, a pre-trained handpose model and the fingerpose library. "
              ghLink="https://github.com/servandongti/GestureRecognition"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              isBlog={false}
              title="Handpose"
              description="Real Time AI hand pose estimation"
              ghLink="https://github.com/servandongti/Handpose"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              isBlog={false}
              title="GEITS"
              description="GEITS student platform"
              ghLink="https://github.com/servandongti/GEITS"
              demoLink="https://geits.tech/"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              isBlog={false}
              title="Campanario Eventos"
              description="Platform for a chain of event halls"
              ghLink="https://github.com/servandongti/Campanario"
              demoLink="https://campanario-eventos.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              isBlog={false}
              title="Traflight"
              description="Mobile app for management and automation of smart traffic lights with motion sensors via Bluetooth connection to Arduino"
              ghLink="https://github.com/yoGhastly/app-semaforo"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
